<template>
  <div>
    <DealerLocator :dealers="dealers" :products="performanceProducts" />
  </div>
</template>

<script>
  import DealerLocator from '@/components/DealerLocator';
  import dealers from '@/assets/data/dealers.json';
  import performanceProducts from '@/assets/data/locator.json';

export default {
  components: {
    DealerLocator
  },
  data() {
    return {
      dealers,
      performanceProducts
    };
  },
  head() {
    const title = 'Dealer Locator';
    const description =
      'Mosaic retailers are equipped with the latest information, data & tools to help you better understand what we can do for your operation. Find a dealer near you.';

    return {
      title,
      meta: [
        { name: 'description', content: description },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description }
      ]
    };
  }
};
</script>